import { module } from 'modujs';
import SplitType from 'split-type';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const shape = this.el.querySelector('.readtext_shape');
        const split = new SplitType(this.el.querySelector('.readtext_content'), { types: 'words' });
        let currentIndex = -1;

        window.addEventListener('readtextProgress', (e) => {
            const { target, progress } = e.detail;
            currentIndex = Math.round((split.words.length+5) * progress);
    
            split.words.forEach((word, index) => {
                if (index < currentIndex) {
                    word.classList.add('active');
                } else {
                    word.classList.remove('active');
                }
            })
        });

        window.addEventListener('readtextShapeProgress', (e) => {
            const { target, progress } = e.detail;
            shape.style.setProperty('--progress', progress);
        });
    }
}
